import React from "react";
import { FiUsers, FiEdit2, FiEye, FiRefreshCw, FiMousePointer, FiTrash2 } from "react-icons/fi";
import { GoCheck, GoAlert, GoSync, GoCircleSlash } from "react-icons/go";
import { getColorFromText } from "../styles";

const STATUS_LABEL = {
  draft: "Rascunho",
  scheduled: "Agendada",
  queued: "Na fila…",
  sending: "Enviando…",
  sent: "Enviada",
  failed: "Falhou",
};

const STATUS_ICON = {
  draft: GoCircleSlash,
  scheduled: GoAlert,
  queued: GoSync,
  sending: GoSync,
  sent: GoCheck,
  failed: GoAlert,
};

const formatDate = (d) => (d ? new Date(d).toLocaleDateString("pt-BR") : "—");

const getInitials = (name) => {
  if (!name) return "EM";
  const parts = name.trim().split(/\s+/);
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
};

export default function CampaignCard({ campaign, listName, onContinueEdit, onSend, onViewDetails, onDelete }) {
  const StatusIcon = STATUS_ICON[campaign.status] || GoCircleSlash;
  const isBusy = campaign.status === "queued" || campaign.status === "sending";
  const eyebrowText =
    campaign.status === "sent"
      ? `ENVIADA · ${formatDate(campaign.sentAt)}`
      : `CRIADA · ${formatDate(campaign.createdAt)}`;
  const hasMetrics = campaign.status === "sent" && !!campaign.metrics;

  return (
    <div className={`campaign-card ${campaign.status} ${hasMetrics ? "has-metrics" : ""}`}>
      <div className="campaign-head">
        <div className="campaign-avatar" style={{ background: getColorFromText(campaign.senderEmail || campaign.name) }}>
          {getInitials(campaign.senderName || campaign.name)}
        </div>
        <div className="campaign-top">
          <span className="campaign-eyebrow">{eyebrowText}</span>
          <h5 title={campaign.name}>{campaign.name}</h5>
          {campaign.subject && <p className="campaign-subject" title={campaign.subject}>{campaign.subject}</p>}
        </div>
        <span className={`status-pill ${campaign.status}`}>
          <StatusIcon />
          {STATUS_LABEL[campaign.status] || campaign.status}
        </span>
      </div>

      <div className="campaign-tags-row">
        {listName && (
          <span className="campaign-list-tag" style={{ background: getColorFromText(listName) }}>
            {listName}
          </span>
        )}
        <span className="campaign-recipients">
          <FiUsers />
          {campaign.recipientsCount || 0} destinatário{campaign.recipientsCount !== 1 ? "s" : ""}
        </span>
        {hasMetrics && (
          <>
            <span className="campaign-recipients" title="Visualizações (aberturas únicas)">
              <FiEye />
              {campaign.metrics.opens ?? 0}
            </span>
            <span className="campaign-recipients" title="Cliques únicos">
              <FiMousePointer />
              {campaign.metrics.clicks ?? 0}
            </span>
          </>
        )}
      </div>

      {hasMetrics && (
        <div className="campaign-metrics">
          <div className="metric-block open">
            <div className="metric-label-row">
              <span>Abertura</span>
              <span>{campaign.metrics.openRate}%</span>
            </div>
            <div className="metric-track">
              <div className="metric-fill" style={{ width: `${campaign.metrics.openRate}%` }} />
            </div>
          </div>
          <div className="metric-block click">
            <div className="metric-label-row">
              <span>Cliques</span>
              <span>{campaign.metrics.clickRate}%</span>
            </div>
            <div className="metric-track">
              <div className="metric-fill" style={{ width: `${campaign.metrics.clickRate}%` }} />
            </div>
          </div>
          <div className="metric-block bounce">
            <div className="metric-label-row">
              <span>Bounce</span>
              <span title="Indisponível nesta fase — requer integração com provedor de email dedicado">
                {campaign.metrics.bounceRate === null || campaign.metrics.bounceRate === undefined
                  ? "—"
                  : `${campaign.metrics.bounceRate}%`}
              </span>
            </div>
            <div className="metric-track">
              <div
                className="metric-fill"
                style={{ width: `${campaign.metrics.bounceRate || 0}%` }}
              />
            </div>
          </div>
        </div>
      )}

      <div className="campaign-actions-row">
        {campaign.status === "draft" && (
          <button className="campaign-action-btn" onClick={() => onContinueEdit(campaign)}>
            <FiEdit2 /> Continuar edição
          </button>
        )}

        {campaign.status === "scheduled" && (
          <button className="campaign-action-btn" onClick={() => onContinueEdit(campaign)}>
            <FiEdit2 /> Editar
          </button>
        )}

        {(campaign.status === "queued" || campaign.status === "sending") && (
          <button className="campaign-action-btn secondary" disabled>
            <GoSync /> {STATUS_LABEL[campaign.status]}
          </button>
        )}

        {campaign.status === "sent" && (
          <button className="campaign-action-btn secondary" onClick={() => onViewDetails(campaign)}>
            <FiEye /> Ver detalhes
          </button>
        )}

        {campaign.status === "failed" && (
          <button className="campaign-action-btn danger" onClick={() => onSend(campaign)}>
            <FiRefreshCw /> Tentar novamente
          </button>
        )}

        {onDelete && (
          <button
            className="campaign-delete-btn"
            title={isBusy ? "Aguarde o envio terminar para excluir" : "Excluir campanha"}
            disabled={isBusy}
            onClick={() => onDelete(campaign)}
          >
            <FiTrash2 />
          </button>
        )}
      </div>
    </div>
  );
}
